// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KWnnP","right":"styles_right__2Lq4J"};